var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('RouterLinkButton',{staticClass:"change-label",attrs:{"type":"text","target":"_blank","to":_vm.toOrderDetail()}},[_vm._v("["+_vm._s(_vm.labelType === 1 ? '改' : '退')+"]")])}
var staticRenderFns = []

export { render, staticRenderFns }